import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { customCredentialsProvider } from './credentials-provider.js';

// Amplify v6 configuration reads from window.heku_aws_config (set by scripts.php).

const cfg = window.heku_aws_config;

export function configureAmplify() {
  const authConfig = {
    Cognito: {
      userPoolId: cfg.UserPoolId,
      userPoolClientId: cfg.ClientId,
      identityPoolId: cfg.IdentityPoolId,
      loginWith: {
        email: true
      }
    }
  };

  // Required without this, Amplify skips token-provider setup and
  // signIn fails with "Auth UserPool not configured".
  cognitoUserPoolsTokenProvider.setAuthConfig(authConfig);

  Amplify.configure(
    {
      Auth: authConfig,
      API: {
        GraphQL: {
          endpoint: cfg.APPSYNC_APIQ_URL,
          region: cfg.Region,
          defaultAuthMode: 'iam'
        },
        REST: {
          readingtrainer: {
            endpoint: cfg.AMAZON_APIQ_URL,
            region: cfg.Region
          }
        }
      }
    },
    {
      Auth: {
        tokenProvider: cognitoUserPoolsTokenProvider,
        credentialsProvider: customCredentialsProvider
      }
    }
  );
}
